import React from 'react';
import { TableRowData, TableColumn, Button } from '@inplayer-org/inplayer-ui';
import GenericTable from 'components/Table/GenericTable';
import CommonIcon from 'components/CommonIcon';

interface OrganizationTableData extends TableRowData {
  name: string;
  id: number;
}
interface RelatedEventTableData extends OrganizationTableData {
  eventName?: string;
  eventId?: number;
}
interface Props {
  organizationsData: Array<any>;
  fetchEvents?: (organizationId: number) => void;
  handleTabChange?: (index: number) => void;
  handleCurrentOrganizationId?: (organizationId: number) => void;
  changeCurrentOrganizationName?: (organizationName: string) => void;
  isEventRelated?: boolean;
  handleDelete?: () => any;
  openDeleteModal?: () => void;
}

const EventbriteOrganizationsTable: React.FC<Props> = ({
  organizationsData,
  fetchEvents,
  handleTabChange,
  handleCurrentOrganizationId,
  changeCurrentOrganizationName,
  isEventRelated = false,
  openDeleteModal,
}) => {
  const handleOnClick = (id: number, name: string) => {
    if (handleCurrentOrganizationId && changeCurrentOrganizationName && fetchEvents && handleTabChange) {
      handleCurrentOrganizationId(id);
      changeCurrentOrganizationName(name);
      fetchEvents(id);
      handleTabChange(1);
    }
  };

  const generateOrganizationColumns = (): Array<TableColumn<OrganizationTableData>> => [
    {
      title: 'Organization name',
      key: 'name',
    },
    {
      title: 'Organization ID',
      key: 'id',
    },
    {
      title: 'Organization events',
      key: 'events',
      render: ({ rowValues }) => {
        const { id, name } = rowValues;
        return <Button onClick={() => handleOnClick(id, name)}>See events</Button>;
      },
    },
  ];

  const generateRelatedEventColumns = (): Array<TableColumn<RelatedEventTableData>> => [
    {
      title: 'Event name',
      key: 'eventName',
    },
    {
      title: 'Event ID',
      key: 'eventId',
    },
    {
      title: 'Organization name',
      key: 'name',
    },
    {
      title: 'Organization ID',
      key: 'id',
    },
  ];

  const renderRowActions = (): any => [
    openDeleteModal && {
      render: () => (
        <span>
          <CommonIcon
            name="delete"
            hoverStatus="delete"
            onClick={(e) => {
              e.preventDefault();
              openDeleteModal();
            }}
          />
        </span>
      ),
    },
  ];

  return (
    <>
      <GenericTable<OrganizationTableData | RelatedEventTableData>
        columns={isEventRelated ? generateRelatedEventColumns() : generateOrganizationColumns()}
        data={organizationsData}
        showLoader={false}
        type="organizations"
        options={{
          rowActions: isEventRelated && renderRowActions(),
        }}
        actionsRowTitle="Edit"
      />
    </>
  );
};

export default EventbriteOrganizationsTable;
